import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useSnapshot } from "valtio";

import { capitalize } from "@helpers/general";
import { store } from "@components/VerticalLayout/store";
import {
    store as storeLogo,
    setIsDataUpdated as setIsDataUpdatedShops,
} from "../store";
import { resetAllPeripherals } from "@pages/Applications/DeviceAssociateModal/store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { AssociateLogo } from "./hooks";
import { useFetchGlobal } from "../../../../api/hooks";

type ConfirmationAssociationModalType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    designation: string;
    setDesignation: Function;
    setSalesSupport: Function;
    setUploadedImage: Function;
    setLocalFilterActive: Function;
    salesSupport: any;
};

export function ConfirmationAssociationBoutiqueModal({
    isModalOpened,
    setIsModalOpened,
    designation,
    setDesignation,
    setSalesSupport,
    setUploadedImage,
    setLocalFilterActive,
    salesSupport,
}: ConfirmationAssociationModalType) {
    const { t } = useTranslation();
    const { dataFranchiseLogo, numberActive } = useSnapshot(storeLogo);
    const { franchiseID, userID, shopID, operatorID } = useSnapshot(store);
    const { fetchGlobal } = useFetchGlobal();
    const uuidUser = localStorage.getItem("uuidUser");

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => setIsModalOpened(!isModalOpened)}
            >
                <span>{capitalize(t("Alert"))}</span>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-0">
                    {t(
                        "The logo already exists in the franchise. do you want to associate it with this shop?"
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setIsModalOpened(!isModalOpened);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>

                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        AssociateLogo(dataFranchiseLogo,designation,userID,shopID,franchiseID,operatorID,
                            uuidUser,salesSupport,setIsDataUpdatedShops,resetAllPeripherals,setDesignation,
                            setSalesSupport,setUploadedImage,numberActive,setLocalFilterActive,clearData,clearMultiCustomSelectionData,fetchGlobal
                        )
                        setIsModalOpened(!isModalOpened);
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
